import { ContactPhoneSelection } from "./ContactPhoneSelection";
import { TruckerConfirmItem } from "./TruckerConfirmItem";

export class TruckerConfirmRequest {
    dispatchId: number = 0;
    truckerId: number = 0;
    truckerContactId: number = 0;
    truckerContactIds: number[] = [];
    scoularUserIds: number[] = [];
    comments: string = '';
    sendEmail: boolean = false;
    sendRoger: boolean = false;
    sendText: boolean = false;
    sendCompuweigh: boolean = false;
    loadBreakoutOverride: boolean = false;
    confirmItems: TruckerConfirmItem[] = [];
    selectedPhones: ContactPhoneSelection[] = []
}